import React from "react";
import { connect } from "react-redux";
import { Application } from "../../..";
import { IAppState } from "../../../../Common";

type StateProps = {
  activeApp?: Application;
};

function mapStateToProps(state: IAppState): StateProps {
  return {
    activeApp: state.app.activeApp
  };
}

const ActiveAppName: React.FC<StateProps> = props => (
  <>
    {!!props.activeApp && <span>{props.activeApp.name}</span>}
    {!props.activeApp && <span>(No App Selected)</span>}
  </>
);

export default connect(mapStateToProps)(ActiveAppName);
